export class Card {

    // Enums for Suit and Rank
    static Suit = {
        Hearts: 'Hearts',
        Diamonds: 'Diamonds',
        Clubs: 'Clubs',
        Spades: 'Spades'
    };

    static Rank = {
        Two: 2,
        Three: 3,
        Four: 4,   
        Five: 5,
        Six: 6,
        Seven: 7,
        Eight: 8,
        Nine: 9,
        Ten: 10,
        Jack: 11,
        Queen: 12,
        King: 13,
        Ace: 14
    };

    cardSuit: string;
    cardRank: number;
    cardImg: string;  // String reference to the image file

    constructor(suit: string, rank: number, imgPath: string) {
        this.cardSuit = suit;
        this.cardRank = rank;
        this.cardImg = imgPath;  // Path to the card image
    }

    // Method to return the string representation of the card
    toString(): string {
        return `${this.getRankName()} of ${this.cardSuit}`;
    }

    // Utility to return rank name
    private getRankName(): string {
        switch (this.cardRank) {
            case Card.Rank.Jack: return 'Jack';
            case Card.Rank.Queen: return 'Queen';
            case Card.Rank.King: return 'King';
            case Card.Rank.Ace: return 'Ace';
            default: return this.cardRank.toString();
        }
    }
}
